var _desc, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _rect8, _rect9, _rect0, _rect1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogWebDevelopment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Modern web development workspace illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Responsive website layout and code blocks on a development screen.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "#07111f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 520c170-70 300-20 470-76 220-72 350-180 730-72v328H0z",
    fill: "#0f766e",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 105,
    width: 740,
    height: 460,
    rx: 32,
    fill: "#111827",
    stroke: "#334155",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 160,
    width: 300,
    height: 72,
    rx: 18,
    fill: "#164e63"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 270,
    width: 245,
    height: 34,
    rx: 17,
    fill: "#22d3ee"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 332,
    width: 365,
    height: 24,
    rx: 12,
    fill: "#64748b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 378,
    width: 310,
    height: 24,
    rx: 12,
    fill: "#64748b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 160,
    width: 245,
    height: 300,
    rx: 24,
    fill: "#0b2433"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M622 235l-54 54 54 54m145-108l54 54-54 54M697 214l-48 150",
    fill: "none",
    stroke: "#14b8a6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 215,
    width: 170,
    height: 290,
    rx: 26,
    fill: "#0f172a",
    stroke: "#38bdf8",
    strokeWidth: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 270,
    width: 106,
    height: 24,
    rx: 12,
    fill: "#22d3ee"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 326,
    width: 106,
    height: 18,
    rx: 9,
    fill: "#64748b"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 370,
    width: 78,
    height: 18,
    rx: 9,
    fill: "#64748b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogWebDevelopment);
export default __webpack_public_path__ + "static/media/blog-web-development.fe336cb0052ae27a34fd002fe5367419.svg";
export { ForwardRef as ReactComponent };